/**
 * @fileoverview State select and profile toggle for the second company address.
 */

import React from "react";
import { IconButton } from "@mui/material";
import ToggleOffIcon from "@mui/icons-material/ToggleOff";
import ToggleOnIcon from "@mui/icons-material/ToggleOn";
import styles from "./Location.module.css";
import Select from "react-select";
import { logger } from "../../../utils/logger.js";
import { getLocationSelectStyles, getSafeSelectedOption } from "./locationSelectUtils";
import {
  CURSOR_NOT_ALLOWED,
  SHOW_IN_PROFILE_KEY,
  TOGGLE_COLOR_ACTIVE,
  TOGGLE_COLOR_INACTIVE,
} from "./locationConstants";

const SecondAddressStateSelect = ({ model, t }) => {
  const {
    handleInputChange, handleToggleChange,
    isAddressReadOnly, secondAddressStateRef,
    secondAddressTownRef, secondAddressZipCodeRef,
    secondAddressNeighborhoodRef, secondAddressStates,
    generalTowns, setSecondAddressTowns,
    generalZipCodes, setSecondAddressZipCodes,
    generalNeighborhoods, setSecondAddressNeighborhoods,
    setSegundoDomicilioCodigoPostal, setSegundoDomicilioColonia,
    setSegundoDomicilioMunicipio, segundoDomicilioEstado,
    setSegundoDomicilioEstado, segundoDomicilioMostrarEstado,
    setSegundoDomicilioMostrarEstado,
  } = model;

  return (
    <div className={styles.inputGroup}>
      <label className={styles.inputLabel}>
        {t("components.location.stateLabel")}
      </label>
      <Select
        ref={secondAddressStateRef}
        isSearchable={true}
        isDisabled={true}
        value={getSafeSelectedOption(
          secondAddressStates,
          segundoDomicilioEstado,
        )}
        onChange={(selectedOption) => {
          logger.info("+++ Second State selectedOption:", {
            data: selectedOption,
          });
          if (!selectedOption) {
            return;
          }

          setSegundoDomicilioEstado(selectedOption._id);
          handleInputChange("domicilio2Estado", selectedOption._id);

          // Clear dependent fields
          secondAddressTownRef.current.clearValue();
          setSegundoDomicilioMunicipio("");
          handleInputChange("domicilio2Municipio", "");

          secondAddressZipCodeRef.current.clearValue();
          setSegundoDomicilioCodigoPostal("");
          handleInputChange("domicilio2CodigoPostal", "");

          secondAddressNeighborhoodRef.current.clearValue();
          setSegundoDomicilioColonia("");
          handleInputChange("domicilio2Colonia", "");

          // Filter towns
          const filteredTowns = generalTowns.filter(
            (town) => town.idEstado == selectedOption._id,
          );
          logger.info("onChange secondState filteredTowns:", {
            data: filteredTowns,
          });
          setSecondAddressTowns(filteredTowns);
          setSecondAddressNeighborhoods(generalNeighborhoods);
          setSecondAddressZipCodes(generalZipCodes);
        }}
        options={secondAddressStates}
        placeholder={t("components.location.statePlaceholder")}
        styles={getLocationSelectStyles()}
        className="select__control"
        getOptionValue={(option) => option._id}
        formatOptionLabel={(option) => <span>{option.nombre}</span>}
      />
      <div className={styles.showInProfileContainer}>
        <span className={styles.showInProfileText}>
          {t(SHOW_IN_PROFILE_KEY)}
        </span>
        <IconButton
          onClick={() => {
            setSegundoDomicilioMostrarEstado(
              !segundoDomicilioMostrarEstado,
            );
            handleToggleChange(
              "domicilio2MostrarEstado",
              !segundoDomicilioMostrarEstado,
            );
          }}
          size="small"
          disabled={isAddressReadOnly}
          className={styles.toggleButton}
          sx={{
            "&.Mui-disabled": {
              cursor: CURSOR_NOT_ALLOWED,
              pointerEvents: "auto",
            },
            "& .MuiSvgIcon-root": {
              color: segundoDomicilioMostrarEstado
                ? TOGGLE_COLOR_ACTIVE
                : TOGGLE_COLOR_INACTIVE,
            },
          }}
        >
          {segundoDomicilioMostrarEstado ? (
            <ToggleOnIcon />
          ) : (
            <ToggleOffIcon />
          )}
        </IconButton>
      </div>
    </div>
  );
};

export default SecondAddressStateSelect;
